import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authenticatedActivateChildGuard } from '../guards/authenticated-activate-child.guard';
import { authenticatedMatchGuard } from '../guards/authenticated-match.guard';
import { selectedSoldtoGuard } from '../guards/selected-soldto.guard';
import { trainingRoleGuard } from '../guards/training-role.guard';
import { SuccessMessageComponent } from '../pages/order/summary/success-message/success-message.component';
import { SummaryComponent } from '../pages/order/summary/summary.component';
import { ShoppingCartProductDetailComponent } from '../pages/shopping-cart/shopping-cart-product-detail/shopping-cart-product-detail.component';
import { AddressSelectorComponent } from '../shared/components/address-selector/address-selector.component';
import { ContactPersonSelectorComponent } from '../shared/components/contact-person-selector/contact-person-selector.component';
import { OutletsEnum } from './outlets.enum';
import { RoutesEnum } from './routes.enum';
import { SummaryRoutesEnum } from './summary-outlet-routes.enum';

export const routes: Routes = [
	{
		path: '',
		redirectTo: RoutesEnum.home,
		pathMatch: 'full',
	},
	{
		path: RoutesEnum.home,
		pathMatch: 'full',
		title: 'home.browserTabTitle',
		canMatch: [authenticatedMatchGuard, trainingRoleGuard],
		canActivate: [selectedSoldtoGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () => import('../pages/home/home.module').then((m) => m.HomeModule),
	},
	{
		path: RoutesEnum.categories,
		pathMatch: 'full',
		title: 'categories.browserTabTitle',
		redirectTo: RoutesEnum.home,
		// canLoad: [AuthenticatedLoadGuard, trainingRoleGuard],
		// canActivate: [AuthenticatedActivateGuard],
		// canActivateChild: [AuthenticatedActivateGuard],
		// loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule)
	},
	{
		path: RoutesEnum.order,
		title: 'order.browserTabTitle',
		pathMatch: 'full',
		canMatch: [authenticatedMatchGuard, trainingRoleGuard],
		canActivate: [selectedSoldtoGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () => import('../pages/order/order.module').then((m) => m.OrderModule),
	},
	{
		path: RoutesEnum.order + '/:orderId',
		title: 'order.browserTabTitle',
		canMatch: [authenticatedMatchGuard, trainingRoleGuard],
		canActivate: [selectedSoldtoGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () => import('../pages/order/order.module').then((m) => m.OrderModule),
	},
	{
		path: RoutesEnum.storeSelection,
		pathMatch: 'full',
		title: 'storeSelection.browserTabTitle',
		canMatch: [authenticatedMatchGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () =>
			import('../pages/store-select/store-select.module').then((m) => m.StoreSelectModule),
	},
	{
		path: RoutesEnum.shoppingCart,
		pathMatch: 'full',
		title: 'shoppingCart.browserTabTitle',
		canMatch: [authenticatedMatchGuard, trainingRoleGuard],
		canActivate: [selectedSoldtoGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () =>
			import('../pages/shopping-cart/shopping-cart.module').then((m) => m.ShoppingCartModule),
	},
	{
		path: RoutesEnum.shoppingCart + '/:cartItemId',
		title: 'shoppingCart.browserTabTitle',
		canMatch: [authenticatedMatchGuard, trainingRoleGuard],
		canActivate: [selectedSoldtoGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () =>
			import('../pages/shopping-cart/shopping-cart.module').then((m) => m.ShoppingCartModule),
	},
	{
		path: RoutesEnum.blankPage,
		pathMatch: 'full',
		title: 'Test - MyZEISS Store',
		canMatch: [authenticatedMatchGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () =>
			import('../pages/blank-page/blank-page.module').then((m) => m.BlankPageModule),
	},
	{
		path: RoutesEnum.settings,
		pathMatch: 'prefix',
		title: 'userManagement.browserTabTitle',
		canMatch: [authenticatedMatchGuard, trainingRoleGuard],
		canActivate: [selectedSoldtoGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () => import('../pages/settings/settings.module').then((m) => m.SettingsModule),
	},
	{
		path: RoutesEnum.noService,
		pathMatch: 'full',
		title: 'userManagement.browserTabTitle',
		canMatch: [authenticatedMatchGuard],
		canActivateChild: [authenticatedActivateChildGuard],
		loadChildren: () =>
			import('../pages/no-service/no-service.module').then((m) => m.NoServiceModule),
	},
	// Drawer routes must be here as they are not lazy loaded
	{
		path: '',
		component: AddressSelectorComponent,
		outlet: OutletsEnum.summary,
	},
	{
		path: SummaryRoutesEnum.summary,
		component: SummaryComponent,
		outlet: OutletsEnum.summary,
	},
	{
		path: SummaryRoutesEnum.storeSelector,
		component: AddressSelectorComponent,
		outlet: OutletsEnum.summary,
	},
	{
		path: SummaryRoutesEnum.shoppingCartStoreSelector,
		component: AddressSelectorComponent,
		outlet: OutletsEnum.summary,
	},
	{
		path: SummaryRoutesEnum.successMessage,
		component: SuccessMessageComponent,
		outlet: OutletsEnum.summary,
	},
	{
		path: SummaryRoutesEnum.shoppingCartSummary,
		component: ShoppingCartProductDetailComponent,
		outlet: OutletsEnum.summary,
	},
	{
		path: SummaryRoutesEnum.contactPersonSelector,
		component: ContactPersonSelectorComponent,
		outlet: OutletsEnum.summary,
	},
	// Fallback route
	// {
	// 	path: '**', // bonus: all routes not defined forward to
	// 	redirectTo: RoutesEnum.categories,
	// },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
